import { Injectable } from 'angular-ts-decorators';

import { ConnectionStatus } from './connection-status';
import { filter } from 'rxjs/operators';

/**
 * Service to handle the logic for syncing requests
 */
@Injectable('syncRequests')
export class SyncRequests {
  constructor(
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $window: ng.IWindowService,
    private connectionStatus: ConnectionStatus,
  ) {
    'ngInject';
  }

  /**
   * Opens the sync modal which shows the progress of the service worker sync.
   * Typically since the sync happens on its own thread - in the worker - its
   * so fast that we need to add a small delay in the UI so the user actually
   * see the syncing taking place.
   * @param {string} showState - string to determine which queue to show
   * @param {array} request - array of requests
   * @param {array} failed - array of failed
   */

  openStatusModal(showState: string, requests: any[], failed: any[]): void {
    this.$uibModal.open({
      component: 'sw-status-modal',
      resolve: {
        showState: () => showState,
        requests: () => requests,
        failed: () => failed,
      },
    });
  }

  /**
   * Starts off the service worker event handler for the sync requests.
   * @param {function} messageHandler function to deal with events received from the service worker
   */

  startServiceWorkerEvents(messageHandler: (...args: any) => void): void {
    if ('serviceWorker' in navigator) {
      //Messenger event - receive messages from the service worker.
      this.$window.navigator.serviceWorker.addEventListener(
        'message',
        messageHandler,
      );

      // Listen for when the app comes back online, then fire off a message
      // to the service worker to sync requests if we have them.
      this.connectionStatus.isOnline$
        .pipe(filter((value) => value))
        .subscribe(() => {
          this.$window.navigator.serviceWorker.ready
            .then((registered) => registered.active)
            .then((sw) => {
              sw.postMessage('sync-requests');
            });
        });

      this.$window.navigator.serviceWorker.ready
        .then((registered) => registered.active)
        .then((sw) => {
          sw.postMessage('sync-requests');
          sw.postMessage('get-all-requests');
        });
    }
  }
}
